import React from "react";
import styled from "styled-components";

// components
import Phone from "../../components/common/phone";

// hooks

const Case = ({ children, phonebg }) => {
  return (
    <BodyOne>
      <BodyTwo>
        <PhoneBackground>
          <Phone phonebg={phonebg}>{children}</Phone>
        </PhoneBackground>
      </BodyTwo>
    </BodyOne>
  );
};

export default Case;

const BodyOne = styled.div`
  display: grid;
  height: 710px;
  width: 360px;
  background-color: #000000;
  border-radius: 30px;
  @media screen and (max-width: 480px) {
    background-color: transparent;
    width: 100vw;
    height: 100vh;
  }
`;

const BodyTwo = styled.div`
  display: grid;
  height: 700px;
  width: 350px;
  border-radius: 30px;
  padding: 5px;
  align-self: center;
  justify-self: center;
  @media screen and (max-width: 480px) {
    height: 100vh;
    width: 100vw;
    padding: 0px;
  }
`;

const PhoneBackground = styled.div`
  display: grid;
  border-radius: 30px;
  background-color: #ffffff;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
  }
`;
